import { Box, Grid } from "@mui/material";
import { useContext } from "react";
import Hero from "../../../components/display/Hero";
import { GlobalDataContext } from "../../../contexts/GlobalData";
import { VIEW_PENDING } from "../../../enums/PermissionTitles";
import AdminDesktopCalendar from "./adminHomePage/AdminDesktopCalendar";
import ClinicInformation from "./adminHomePage/ClinicInformation";
import PendingSidebar from "./adminHomePage/PendingSidebar";

export default function AdminDesktopHomePage() {
  const { isPermissionAllowed } = useContext(GlobalDataContext);
  const canViewPending = isPermissionAllowed(VIEW_PENDING);
  return (
    <>
      <Hero />
      <Box sx={{ ml: 5, mr: 5, mb: 5 }}>
        <Grid container spacing={2}>
          <Grid item lg={canViewPending ? 8 : 12} md={12} sm={12}>
            <AdminDesktopCalendar />
          </Grid>
          {canViewPending ? <Pending /> : null}
          <Grid item xs={12}>
            <ClinicInformation />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

function Pending() {
  return (
    <Grid item lg={4} md={12} sm={12}>
      <PendingSidebar />
    </Grid>
  );
}
